const isProduction = process.env.NODE_ENV === "production";

interface Debugger {
  log: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  error: (...args: any[]) => void;
}

/**
 * Creates a scoped debugger instance.
 * In production, all methods are no-ops to avoid leaking logs.
 * @param namespace - The namespace for the logs (e.g., 'MyComponent', 'ApiService:fetch').
 * @returns A debugger object with log, warn, and error methods.
 */
export const createDebug = (namespace: string): Debugger => {
  if (isProduction) {
    return {
      log: () => {},
      warn: () => {},
      error: () => {},
    };
  }

  const prefix = `[${namespace}]`;

  return {
    log: (...args: any[]) => console.log(prefix, ...args),
    warn: (...args: any[]) => console.warn(prefix, ...args),
    error: (...args: any[]) => console.error(prefix, ...args),
  };
};

// Default debugger if no namespace is needed (less common)
const defaultDebug = createDebug("App");
export default defaultDebug;
